import { StoreLogo } from 'components/storeLogo/storeLogo';
import { SecureLabel } from 'components/secureLabel/secureLabel';
import { LogoutButton } from 'components/logoutButton/logoutButton';

import template from './header.html';
import './header.scss';

export const Header = angular
    .module('checkout.components.header', [
        StoreLogo,
        SecureLabel,
        LogoutButton
    ]).component('checkoutHeader', {
        template,
        bindings: {
            storeInfo: '<',
            returnUrl: '<',
            isLoggedIn: '<',
            loggedInShopperName: '<',
            useNewCarts: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/header/header.js